import React from 'react';

const GiftedSolutionsLogo = ({ 
  size = 'medium', 
  showTagline = true, 
  className = '',
  variant = 'default' // 'default', 'white', 'minimal'
}) => {
  const sizeClasses = {
    small: 'h-8',
    medium: 'h-12',
    large: 'h-16',
    xlarge: 'h-20'
  };

  const textSizes = {
    small: 'text-lg',
    medium: 'text-xl',
    large: 'text-2xl',
    xlarge: 'text-3xl'
  };

  const taglineSizes = {
    small: 'text-xs',
    medium: 'text-sm',
    large: 'text-base',
    xlarge: 'text-lg'
  };

  const getColors = () => {
    switch (variant) {
      case 'white':
        return {
          primary: 'text-white',
          secondary: 'text-gray-200',
          accent: 'fill-white'
        };
      case 'minimal':
        return {
          primary: 'text-gray-800',
          secondary: 'text-gray-600',
          accent: 'fill-gray-800'
        };
      default:
        return {
          primary: 'text-primary-600',
          secondary: 'text-secondary-800',
          accent: 'fill-primary-600'
        };
    }
  };

  const colors = getColors();

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Minimalistic Icon */}
      <div className={`${sizeClasses[size]} flex items-center justify-center`}>
        <svg
          viewBox="0 0 48 48"
          className={`${sizeClasses[size]} w-auto`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Background with gradient */}
          <defs>
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#00b300" />
              <stop offset="100%" stopColor="#006600" />
            </linearGradient>
            <linearGradient id="logoGradientWhite" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#ffffff" />
              <stop offset="100%" stopColor="#f0f0f0" />
            </linearGradient>
            <linearGradient id="logoGradientMinimal" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#374151" />
              <stop offset="100%" stopColor="#1f2937" />
            </linearGradient>
          </defs>

          {/* Main rounded square background */}
          <rect
            x="4"
            y="4"
            width="40"
            height="40"
            rx="12"
            ry="12"
            fill={variant === 'white' ? 'url(#logoGradientWhite)' : variant === 'minimal' ? 'url(#logoGradientMinimal)' : 'url(#logoGradient)'}
            stroke={variant === 'white' ? '#e5e7eb' : 'none'}
            strokeWidth={variant === 'white' ? '1' : '0'}
          />

          {/* Letter "G" in clean, modern style */}
          <path
            d="M24 12 C30 12 35 17 35 23 C35 29 30 34 24 34 C18 34 13 29 13 23 C13 17 18 12 24 12 Z M24 16 C20 16 17 19 17 23 C17 27 20 30 24 30 C26.5 30 28.5 28.5 29.5 26.5 L26 26.5 L26 24 L32 24 L32 26.5 C30.5 31 27.5 34 24 34"
            fill={variant === 'white' ? '#374151' : variant === 'minimal' ? '#ffffff' : '#ffffff'}
            strokeWidth="0"
          />

          {/* Small accent element - modern dot */}
          <circle
            cx="32"
            cy="16"
            r="2.5"
            fill={variant === 'white' ? '#00b300' : variant === 'minimal' ? '#10b981' : '#ffffff'}
            opacity="0.9"
          />
        </svg>
      </div>

      {/* Text Content */}
      <div className="flex flex-col">
        <div className={`font-bold ${textSizes[size]} leading-tight tracking-tight`}>
          <span className={colors.primary}>Gifted</span>
          <span className={`ml-1 ${colors.secondary} font-normal`}>solutions</span>
        </div>
        {showTagline && (
          <div className={`${taglineSizes[size]} ${colors.secondary} font-medium leading-tight tracking-wide uppercase opacity-75`}>
            Branding & Marketing
          </div>
        )}
      </div>
    </div>
  );
};

export default GiftedSolutionsLogo;
